module.exports = "/virtual-football-league/img/amblems/right/France/Fake_PSG.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/amblems/right/France/Fake_PSG.png
// module id = 2137
// module chunks = 4